const maskSensitive = (text: string, end?: number, start?: number): string => {
  return Array.from(text).reduce((acc, char, index) => {
    if (start && index < start) return acc;
    if (!end) return acc + "*";
    return index <= end ? acc + "*" : acc + char;
  }, "");
};

export default maskSensitive;
